module.exports = __webpack_public_path__ + "static/img/banner-shop-new.fc94b322.png";